export const REDIRECT_TIMEOUT_MS = 15_000;
